import type { MedplumClient } from '@medplum/core';
import { attachmentDataUrl, createSecuredAttachment } from '../createSecuredAttachment';

const MAX_GROUP_IMAGE_BYTES = 3 * 1024 * 1024;

/**
 * Upload a photo Binary for a Group Template (`HealthcareService.photo`).
 *
 * Returns a stable `Binary/{id}` reference. The server populates `Binary.url`
 * with a presigned storage URL that expires after an hour, so callers should
 * persist the Binary id reference (via `setGroupTemplatePhoto`), not the URL.
 */
export async function uploadGroupImage(
  medplum: MedplumClient,
  file: File,
  organizationId: string,
): Promise<string> {
  if (file.size > MAX_GROUP_IMAGE_BYTES) {
    throw new Error('Image must be 3 MB or smaller.');
  }
  if (!file.type.startsWith('image/')) {
    throw new Error('Please upload an image file.');
  }
  const attachment = await createSecuredAttachment(
    medplum,
    file,
    { reference: `Organization/${organizationId}` },
    file.name,
    file.type || 'image/jpeg',
  );
  return attachmentDataUrl(attachment);
}
